import CostCenterComponent from './cost_center.component';
import CostCenterCreate from './create';
import CostCenterEdit from './edit';
import CostCenterAll from './all';

let CostCenterModule = angular.module('costCenter', [
    CostCenterCreate,
    CostCenterEdit,
    CostCenterAll
])

    .component('costCenter', CostCenterComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $stateProvider
            .state('cost_center.edit', {
                url: '/edit/:id',
                component: 'costCenterEdit',
                data: {
                    requireACL: 'tnt_control_cost_center.edit'
                }
            })

            .state('cost_center.create', {
                url: '/create',
                component: 'costCenterCreate',
                data: {
                    requireACL: 'tnt_control_cost_center.create'
                }
            })

            .state('cost_center.all', {
                url: '/all/:page',
                component: 'costCenterAll',
                data: {
                    requireACL: 'tnt_control_cost_center.view'
                }
            });
    })

    .name;

export default CostCenterModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/index.js